import { HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CrudApiOptions, GenResp } from "@template-ui/services/crud-api.service";
import { AppBaseService } from "@app/shared/services/app-base.service";
import { map, Observable } from "rxjs";

export interface DataResetResult {
  resetAtUtc: string;
  inmates: number;
  scheduledProceedings: number;
  documents: number;
}

const requestHeaders = new HttpHeaders({
  "Content-Type": "application/json",
  Accept: "application/json, text/plain, */*",
  "skip-error-interceptor": "yes",
  "skip-loading-interceptor": "yes",
});

const dataResetAdminApiOptions: Partial<CrudApiOptions<"body", "json">> = {
  retries: 0,
  feedbackOptions: {
    successMode: "none",
    errorMode: "none",
  },
  getOptions: {
    responseType: "json",
    headers: requestHeaders,
    withCredentials: true,
  },
  postOptions: {
    responseType: "json",
    headers: requestHeaders,
    withCredentials: true,
  },
  putOptions: {
    responseType: "json",
    headers: requestHeaders,
    withCredentials: true,
  },
};

@Injectable({ providedIn: "root" })
export class PlatformDataResetAdminService extends AppBaseService {
  resetDemoData(): Observable<DataResetResult> {
    return this.crudService.postByUrl<DataResetResult>(
      this.apis.core.manual.postPhmsAdminDataReset(),
      {},
      dataResetAdminApiOptions,
    ).pipe(map((response) => unwrapResponse(response)));
  }
}

function unwrapResponse<T>(response: GenResp<T> | T | undefined | null): T {
  if (response && typeof response === "object" && "data" in response) {
    return (response as GenResp<T>).data;
  }

  return response as T;
}
